<app-base-modal modalName="edit-drivers-name"
  [inProcessModal]="inProcessModal"
  [customCloseAction]="close.bind(this)"
  [hideClose]="false">
  <ng-template>
    <div id="edit-drivers-modal"
      class="d-flex justify-content-start flex-column edit-drivers-modal">
      <h2>{{s.title}}</h2>
      <div class="scrollable-modal-section edit-driver-container">
        @for (driver of driversList; track driver; let i = $index) {
          <div class="driver-card"
            >
            @if (i===0 || i !== indexToRemove) {
              <div class="edit-driver-wrapper"
                >
                <div class="driver-name">{{driver}}</div>
                <div class="second-row">
                  <div class="badge-icon-section success-badge">
                    <span class="badge-icon success-icon"></span>
                    <span class="badge-text">
                      {{i>0?s.aD:s.policyHolder}}
                    </span>
                  </div>
                  <div class="action-buttons">
                    @if (i !== 0) {
                      <a class="remove hyperlink"
                        id="remove-ad-{{i-1}}"
                        [ngClass]="{'disabled': indexToRemove}"
                      (click)="onDeleteAdditionalDriver(i)">{{s.remove}}</a>
                    }
                    <a class="edit hyperlink"
                      id="edit-driver-{{i-1}}"
                      [ngClass]="{'disabled': indexToRemove}"
                    (click)="onEditAdditionalDriver(i, $event)">{{s.edit}}</a>
                  </div>
                </div>
              </div>
            }
            @if (i === indexToRemove) {
              <div class="remove-driver-wrapper"
                >
                <div class="remove-driver-row">
                  <div class="warning-icon"></div>
                  <div class="remove-text">{{s.areYouSure}}</div>
                </div>
                <div class="second-row justify-content-end">
                  <div class="action-buttons ">
                    @if (i !== 0) {
                      <a class="remove hyperlink"
                        id="remove-ad-{{i}}"
                      (click)="onConfirmDeleteAdditionalDriver(i, $event)">{{s.yesRemove}}</a>
                    }
                    <a class="edit hyperlink"
                      id="edit-driver-{{i}}"
                    (click)="indexToRemove = undefined; triggerGtmEvent(gtmEventIds.driversRemoveCancel, $event);">{{s.cancel}}</a>
                  </div>
                </div>
              </div>
            }
          </div>
        }
      </div>
      @if (showAdditionalDriverLink) {
        <a class="add-driver-wrapper hyperlink"
          id="editAdDrivers"
          [ngClass]="{'disabled': indexToRemove}"
          (click)="onAddAdditionalDrivers($event)">
          <div class="blue-plus-icon"></div>
          <div>{{s.addDriver}}</div>
        </a>
      }
      <button type="button"
        class="app-alt-submit-btn"
        id="close_drivers_modal"
        [disabled]="waiting"
        (click)="close()">
        {{s.close}}
      </button>
    </div>
  </ng-template>
</app-base-modal>